import React, { useId, useState } from 'react';
import { COLORS, EXTRA_COLOR_PALETTES } from '../../config/colors';
import './ColorPickerWidget.css';

const TABS = ['Theme', 'Palettes', 'Custom'];

function ColorPickerWidget({ x = 0, y = 0, onColorSelect, onClose, colors = null, style = {} }) {
  const [tab, setTab] = useState('Theme');
  const [palette, setPalette] = useState(0);
  const [hex, setHex] = useState('#7c3aed');
  const id = useId();
  const validHex = /^#[0-9a-f]{6}$/i.test(hex);
  const paletteColors = tab === 'Palettes'
    ? EXTRA_COLOR_PALETTES[palette].colors
    : (Array.isArray(colors) && colors.length ? colors : COLORS);

  return (
    <div className="idea-color-picker" style={{ left: x, top: y, ...style }}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => {
        event.stopPropagation();
        if (event.key === 'Escape') { event.preventDefault(); onClose?.(); }
      }}>
      <div role="tablist" aria-label="Colour options" className="idea-color-picker__tabs">
        {TABS.map((name, index) => (
          <button key={name} type="button" role="tab" id={`${id}-${name}`}
            aria-selected={tab === name} aria-controls={`${id}-panel`}
            tabIndex={tab === name ? 0 : -1}
            onClick={() => setTab(name)}
            onKeyDown={(event) => {
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % TABS.length;
              if (event.key === 'ArrowLeft') next = (index + TABS.length - 1) % TABS.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = TABS.length - 1;
              if (next === undefined) return;
              event.preventDefault();
              setTab(TABS[next]);
              event.currentTarget.parentElement.children[next].focus();
            }}>{name}</button>
        ))}
      </div>
      <div role="tabpanel" id={`${id}-panel`} aria-labelledby={`${id}-${tab}`}>
        {tab === 'Custom' ? (
          <div className="idea-color-picker__custom">
            <label htmlFor={`${id}-visual`}>Choose a colour</label>
            <input id={`${id}-visual`} type="color" value={validHex ? hex : '#7c3aed'}
              onChange={(event) => setHex(event.target.value)} />
            <label htmlFor={`${id}-hex`}>Hex colour</label>
            <input id={`${id}-hex`} type="text" value={hex} maxLength={7}
              spellCheck={false} autoComplete="off" aria-invalid={!validHex}
              aria-describedby={!validHex ? `${id}-error` : undefined}
              onChange={(event) => setHex(event.target.value)} />
            {!validHex && <p id={`${id}-error`}>Enter # followed by six letters or numbers (0–9, A–F).</p>}
            <button type="button" disabled={!validHex}
              onClick={() => onColorSelect?.({ name: `Custom ${hex.toUpperCase()}`, gradient: hex.toLowerCase() })}>
              Apply colour
            </button>
          </div>
        ) : (
          <>
            {tab === 'Palettes' && <label className="idea-color-picker__palette">Palette
              <select value={palette} onChange={(event) => setPalette(Number(event.target.value))}>
                {EXTRA_COLOR_PALETTES.map((entry, index) => <option key={entry.name} value={index}>{entry.name}</option>)}
              </select>
            </label>}
            <div className="idea-color-picker__grid">
              {paletteColors.map((color, index) => (
                <button key={color.slot ?? color.name ?? index} type="button"
                  style={{ background: color.gradient }}
                  onClick={() => onColorSelect?.(color)}
                  aria-label={`Use ${color.name}`} title={color.name} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export { ColorPickerWidget };
